module.exports = __webpack_public_path__ + "static/media/ic_notification_sent.f689ff4e.svg";